import { css, createGlobalStyle } from '../../theming';
import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json';
import { ExpandedState } from './types';

// If the mobile menu is expanded, do not allow scrolling the page 'behind' the menu
const bodyNoScroll = css`
  body {
    position: fixed;
    overflow: hidden;
    width: 100%;

    @media (min-width: ${tokens.viewports.breakpoints.small}) {
      overflow: visible;
      position: static;
    }
  }
`;

const GlobalBodyStyles = createGlobalStyle<ExpandedState>`
  ${({ isMobileMenuExpanded }) => isMobileMenuExpanded && bodyNoScroll};
`;

export default GlobalBodyStyles;
